export class CommonHelp {
  static debounce(fn, delay = 500,that) {
    // 函数防抖在执行目标方法时，会等待一段时间
    if (that._timer) {
      clearTimeout(that._timer)
    }
    that._timer = setTimeout(() => {
      fn();
      that._timer = null
    }, delay)
  }

  static throttle(fn, delay=500,that) {
    // 在延时的时间内，方法若被触发，则直接退出方法
    if (that._timer) {
      return
    }
    that._timer = setTimeout(() => {
      fn();
      that._timer = null
    },delay)
  }

  static loadJs(url, callback) {
    let script_list=document.getElementsByTagName('script');
    let script_srcs=[];
    script_list.forEach(item => {
      script_srcs.push(item.src);
    })
    if(!script_srcs.includes(url)){
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      let head = document.getElementsByTagName('head')[0];
      head.appendChild(script);
      if (typeof callback === 'function') {
        script.onload = function() {
          callback();
        }
      }
    }

  }

}



// WEBPACK FOOTER //
// ./src/components/Admin/Butler/common/CommonHelp.js